// @ts-strict-ignore
import { Material } from 'three';
import { ArticleUtils } from '@article/util/article-utils';
import { ArticleVO } from '@article/model/vo/article.vo';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { IArticleTextureParameters } from './i-article-texture-parameters';
import { IArticleTextureParametersGenerator } from './i-article-texture-parameters-generator';
import { CustomArticleTextureParametersGenerator } from './custom-article-texture-parameters-generator';
import { DefaultArticleTextureParametersGenerator } from './default-article-texture-parameters-generator';
import { ProjectUserModel } from '../../../model/project-user.model';

export class ArticleParametersCreator {
  public customArticleGenerator: CustomArticleTextureParametersGenerator;
  public defaultArticleGenerator: DefaultArticleTextureParametersGenerator = new DefaultArticleTextureParametersGenerator();

  constructor(projectUserModel: ProjectUserModel) {
    this.customArticleGenerator = new CustomArticleTextureParametersGenerator(projectUserModel);
  }

  public createArticleParameters(articleContainer: ArticleContainer, material: Material): IArticleTextureParameters {
    if (!articleContainer) {
      return null;
    }
    const parametersGenerator: IArticleTextureParametersGenerator = this.getParameterGeneratorByArticle(articleContainer.article);
    return parametersGenerator.generateParameters(articleContainer, material);
  }

  private getParameterGeneratorByArticle(article: ArticleVO): IArticleTextureParametersGenerator {
    if (ArticleUtils.isCustomArticle(article)) {
      return this.customArticleGenerator;
    } else {
      return this.defaultArticleGenerator;
    }
  }
}
